import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/authSlice';

export const useAuth = () => {
  const user = useSelector(selectCurrentUser);

  return useMemo(() => ({ user }), [user]);
};

export interface IPreferences {
  screenName: String;
  referralCode: String;
  profilePic: string;
  bio: String;
}
